import {
  AccessTime,
  Computer,
  Edit,
  FilterVintage,
  Image,
  ManageAccounts,
  Security,
} from '@mui/icons-material'
import { Box, Container, Grid, Stack, styled, Typography } from '@mui/material'
import React from 'react'
import '../../styles/features.css'

const ServiceContainer = styled('Box')({
  display: 'flex',
  marginTop: '2rem',
})

const Features = () => {
  return (
    <>
      <Box>
        <ServiceContainer>
          <Box
            flex={1}
            display='flex'
            flexDirection={'column'}
            alignItems='center'
            justifyContent='center'
          >
            <Box width={'50%'}>
              <Typography variant='h3'>
                The perfect place to fast track your career
              </Typography>
              <Typography variant='body2'>
                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Quod
                voluptatum incidunt, maiores voluptates at alias!
              </Typography>
              <div className='app-store-logos'>
                {/* <Button></Button>
              <Button></Button> */}
                <img
                  src='https://cn.maplesoft.com/products/MapleCalculator/images/app-store-icons-google-play.png'
                  alt='get it on google play'
                />

                <img
                  src='https://static.vecteezy.com/system/resources/previews/002/520/835/original/download-application-button-apple-app-store-free-vector.jpg'
                  alt='get it on apple store'
                />
              </div>
            </Box>
          </Box>
          <Box flex={1}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='100%'
              height='458.46641'
              viewBox='0 0 524.67004 458.46641'
              xmlnsXlink='http://www.w3.org/1999/xlink'
            >
              <g>
                <g>
                  <polygon
                    points='366.92509 451.64652 358.96824 451.64574 355.18311 420.95467 366.92669 420.9555 366.92509 451.64652'
                    fill='#ffb6b6'
                  />
                  <path
                    d='M339.66391,451.46602h0c-.24775,.41726-.37847,1.76397-.37847,2.2492h0c0,1.49148,1.20906,2.70059,2.70059,2.70059h24.64145c1.01748,0,1.84235-.82483,1.84235-1.84235v-1.0259s1.21899-3.08337-1.29069-6.88379c0,0-3.1192,2.97579-7.78008-1.6851l-1.37445-2.48993-9.94915,7.27631-5.51466,.6788c-1.2065,.14849-2.27617-.02305-2.89677,1.02217h-.0001Z'
                    fill='#2f2e41'
                  />
                </g>
                <g>
                  <polygon
                    points='450.92097 441.69286 443.64997 444.92459 427.72316 418.41788 438.45435 413.64786 450.92097 441.69286'
                    fill='#ffb6b6'
                  />
                  <path
                    d='M425.93735,452.60265h0c-.05688,.48192,.37077,1.7656,.56789,2.20899h0c.60591,1.36286,2.2019,1.97652,3.5648,1.3706l22.51647-10.01047c.92973-.41335,1.34839-1.50214,.93503-2.43192l-.41677-.93743s-.13874-3.31268-3.9759-5.76582c0,0-1.64131,3.98633-7.79372,1.62084l-2.26745-1.71684-6.13521,10.69062-4.76334,2.86057c-1.04213,.62582-2.08924,.90362-2.23171,2.11083l-.00009,.00004Z'
                    fill='#2f2e41'
                  />
                </g>
                <polygon
                  points='349.63242 259.6055 342.55798 274.46181 354.58452 428.68442 369.62465 428.68442 375.80781 327.52005 429.78517 428.68442 448.23439 428.68442 420.37673 356.52521 401.27577 262.43528 349.63242 259.6055'
                  fill='#2f2e41'
                />
                <path
                  d='M387.5115,164.33088h-18.65447l-6.84156,10.73517-15.43181,7.38043,3.35474,46.29542-1.68299,33.75529,2.3061-.06729c16.46312-.48041,32.91858,2.19746,48.1967,8.34923,3.91962,1.57824,8.02835,2.45869,11.56551,1.5744,0,0-1.3419-5.36758-2.68379-6.70948s-2.01284-2.45134-1.3419-3.23851,2.01284-1.45812,.67095-2.80002-1.3419-3.03247-1.3419-3.03247l-4.02569-29.84398,8.05138-42.26973-16.7737-9.39327-5.36758-10.73517Z'
                  fill='#00bfa6'
                />
                <polygon
                  points='419.56742 222.85848 419.05892 262.45207 409.20728 297.74739 401.33194 294.80974 404.8286 262.458 404.36895 218.67767 419.56742 222.85848'
                  fill='#ffb6b6'
                />
                <ellipse
                  cx='403.7173'
                  cy='302.44532'
                  rx='9.34055'
                  ry='5.54595'
                  transform='translate(33.84638 645.456) rotate(-79.68097)'
                  fill='#ffb6b6'
                />
                <path
                  d='M405.6271,182.44648s11.11555,1.72228,11.26083,11.26083,10.88045,24.97036,4.17097,37.04743l-17.44465,2.68379-9.39327-34.21835,10.73517-18.1156'
                  fill='#00bfa6'
                />
                <polygon
                  points='354.89126 215.88554 332.73963 248.70651 305.13579 272.8072 300.16406 266.02983 320.8399 240.90273 344.47961 204.05042 354.89126 215.88554'
                  fill='#ffb6b6'
                />
                <ellipse
                  cx='297.96827'
                  cy='273.72207'
                  rx='9.34055'
                  ry='5.54595'
                  transform='translate(-105.73809 300.74123) rotate(-46.40043)'
                  fill='#ffb6b6'
                />
                <path
                  d='M365.41289,174.45177s8.34745,7.53935,3.23473,15.59324-4.60622,26.8456-16.84246,33.26019l-16.05633-7.32893c1.35263-13.2314,2.1416-26.9498,10.9242-33.76076l18.9153-9.25374'
                  fill='#00bfa6'
                />
                <g>
                  <circle
                    cx='375.28975'
                    cy='144.87397'
                    r='16.69164'
                    fill='#ffb6b6'
                  />
                  <path
                    d='M387.54887,158.58853c.91941,.15676,1.99877-2.07178,3.03018-4.24226,2.15919-4.54357,3.53176-7.43194,3.63622-11.51469,.08903-3.47968-.87769-2.56641-1.81811-10.30262-.31016-2.55161-4.66937-2.5467-5.5566-3.75833-1.49867-2.04663,.80075-2.89069-2.92791-4.12015-6.98407-2.30282-10.14225,1.27453-14.57763,1.58272-.11208,.0078-2.31088,2.15811-3.5389,2.2693-2.15151,.19481-5.25531-.14031-6.64679-3.41835-1.30105-3.06501-2.16288,5.89157-1,7,.98732,.94109,2.69047,3.3032,2.73393,3.47498,.0492,.19442-4.0497-4.34613-4.73393-2.47498-.49244,1.34664,1.05766,8.27494,2.30979,8.53535,1.0471,.21772,3.60797-3.23361,3.03018-1.81811-1.33997,3.28276,6.7173,5.37739,16.36299-1.21207,.34204-.2337,.01894,.13901,1.21207,3.03018,1.50477,3.64643,1.84437,3.84395,1.81811,4.84829-.05685,2.1741-1.68924,2.81424-1.21207,4.24226,.38647,1.15659,1.89675,2.05196,3.03018,1.81811,1.27902-.26396,1.4983-1.84622,2.42415-1.81811,.79306,.02412,1.73425,1.21858,1.81811,2.42415,.17663,2.53978-3.58336,3.23829-4.24226,6.6664-.37186,1.9347,4.00338-1.35611,4.84829-1.21207Z'
                    fill='#2f2e41'
                  />
                </g>
              </g>
              <g>
                <path
                  d='M255.41218,457.17619H111.98738c-21.51191,0-39.01333-17.50142-39.01333-39.01374V39.01333C72.97405,17.50142,90.47547,0,111.98738,0H255.41218c21.51151,0,39.01291,17.50142,39.01291,39.01333,2.6698,152.25461,7.2226,322.75577,0,379.14914,0,21.51233-17.5014,39.01372-39.01291,39.01372Z'
                  fill='#3f3d56'
                />
                <path
                  d='M296.42527,139.4635c-.91025,0-1.65045,.74021-1.65045,1.65045v52.81453c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-52.81453c0-.91025-.74021-1.65045-1.65045-1.65045Z'
                  fill='#3f3d56'
                />
                <path
                  d='M290.71194,39.01362V418.15594c0,18.7244-14.57349,34.04062-33.00082,35.22894h-.00826c-.27234,.01652-.54463,.03304-.82523,.0413-.48691,.02473-.97376,.03299-1.46888,.03299,0,0-1.81551-.13206-5.13294-.37962-3.35042-.24756-8.22749-.61892-14.30946-1.10578-1.82372-.14032-3.74651-.29712-5.77659-.46213-4.04358-.33011-8.48331-.69321-13.24488-1.10583-1.89801-.1568-3.86206-.33006-5.86735-.50338-10.24931-.883-21.72824-1.91453-33.83431-3.08634-2.04655-.18984-4.10961-.38788-6.1892-.59419-.54463-.05777-94.3661-23.64272-94.3661-28.06598V39.01362c0-19.50007,15.80312-35.30319,35.30324-35.30319h21.07628c3.36694,0,6.07366,2.62422,6.36252,5.9829,.02473,.22283,.04951,.4456,.09076,.66843,.61066,3.3752,3.70526,5.72708,7.13818,5.72708h74.08205c3.43292,0,6.52752-2.35188,7.13818-5.72708,.04125-.22283,.06603-.4456,.09081-.66843,.28881-3.35868,2.99553-5.9829,6.36247-5.9829h21.07633c19.50007,0,35.30319,15.80312,35.30319,35.30319Z'
                  fill='#fff'
                />
                <path
                  d='M72.14898,99.8526c-.91025,0-1.65045,.74021-1.65045,1.65045v13.20363c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-13.20363c0-.91025-.74021-1.65045-1.65045-1.65045Z'
                  fill='#3f3d56'
                />
                <path
                  d='M72.14898,139.4635c-.91025,0-1.65045,.74021-1.65045,1.65045v25.58204c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-25.58204c0-.91025-.74021-1.65045-1.65045-1.65045Z'
                  fill='#3f3d56'
                />
                <path
                  d='M72.14898,175.77349c-.91025,0-1.65045,.74021-1.65045,1.65045v25.58204c0,.91025,.74021,1.65045,1.65045,1.65045s1.65045-.74021,1.65045-1.65045v-25.58204c0-.91025-.74021-1.65045-1.65045-1.65045Z'
                  fill='#3f3d56'
                />
                <rect
                  x='100.61931'
                  y='9.49024'
                  width='32.18385'
                  height='4.12614'
                  rx='.31021'
                  ry='.31021'
                  fill='#e6e6e6'
                />
                <circle
                  cx='239.54767'
                  cy='10.31547'
                  r='3.30091'
                  fill='#e6e6e6'
                />
                <circle
                  cx='248.62517'
                  cy='10.31547'
                  r='3.30091'
                  fill='#e6e6e6'
                />
                <circle
                  cx='257.70266'
                  cy='10.31547'
                  r='3.30091'
                  fill='#e6e6e6'
                />
              </g>
              <path
                d='M258.75225,303.72529c0-37.62527-31.80087-58.32329-68.12658-68.12658-46.57288-12.5687-80.6821,12.86459-68.12659,68.12659,8.336,36.69019,50.64836,91.44583,68.12659,58.12657,20-38.12658,68.12658-20.50131,68.12658-58.12658Z'
                fill='#f2f2f2'
              />
              <path
                d='M0,457.27641c0,.66003,.53003,1.19,1.19006,1.19H523.48004c.65997,0,1.19-.52997,1.19-1.19,0-.65997-.53003-1.19-1.19-1.19H1.19006c-.66003,0-1.19006,.53003-1.19006,1.19Z'
                fill='#ccc'
              />
              <g>
                <path
                  d='M167.21108,297.00903l-8.22992-3.89856c3.37555,4.71082,6.28418,12.06805,7.84137,17.92249,2.63654-5.45343,6.88672-12.1261,11.09375-16.11194l-8.69812,2.23767c5.35974-26.26794,25.5191-45.12573,48.60437-45.12573l.32679-.9488c-24.11316,0-45.46577,18.59639-50.93824,45.92488Z'
                  fill='#3f3d56'
                />
                <path
                  d='M205.0903,337.03299h-52c-2.20557,0-4-1.79443-4-4s1.79443-4,4-4h52c2.20557,0,4,1.79443,4,4s-1.79443,4-4,4Z'
                  fill='#00bfa6'
                />
              </g>
              <g>
                <path
                  d='M253.69993,129.72529v106c0,9.37402-7.62598,17-17,17h-106c-9.37402,0-17-7.62598-17-17v-106c0-9.37402,7.62598-17,17-17h106c9.37402,0,17,7.62598,17,17Zm-17,121c8.28427,0,15-6.71573,15-15v-53.44094c0-37.31184-30.24722-67.55906-67.55906-67.55906h-53.44094c-8.28427,0-15,6.71573-15,15v106c0,8.28427,6.71573,15,15,15h106Z'
                  fill='#3f3d56'
                />
                <g>
                  <path
                    d='M197.8104,156.01748h-34.22061c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.56471-1.56439,1.56471Z'
                    fill='#3f3d56'
                  />
                  <path
                    d='M197.8104,189.3811h-34.22061c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.56471-1.56439,1.56471Z'
                    fill='#3f3d56'
                  />
                  <path
                    d='M180.8104,235.3811h-34.22061c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h34.22061c.86273,0,1.56439,.70166,1.56439,1.56439s-.70166,1.56471-1.56439,1.56471Z'
                    fill='#3f3d56'
                  />
                  <path
                    d='M216.17354,172.71023h-70.94689c-.86273,0-1.56471-.70199-1.56471-1.56472s.70199-1.56439,1.56471-1.56439h70.94689c.86273,0,1.56439,.70166,1.56439,1.56439,0,.86273-.70166,1.56471-1.56439,1.56471Z'
                    fill='#3f3d56'
                  />
                </g>
              </g>
            </svg>
          </Box>
        </ServiceContainer>

        <Container sx={{ display: 'flex', gap: '1rem' }}>
          <Box flex={1} className='feature-svg-container'>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              data-name='Layer 1'
              width='1139.17088'
              height='654.54324'
              viewBox='0 0 1139.17088 654.54324'
              xmlnsXlink='http://www.w3.org/1999/xlink'
            >
              <title>progressive_app</title>
              <circle
                cx='246.82682'
                cy='521.76476'
                r='59.24334'
                fill='#f2f2f2'
              />
              <circle cx='256.45989' cy='513.095' r='59.24334' fill='#00bfa6' />
              <rect
                x='304.17137'
                y='447.54324'
                width='732.99951'
                height='2'
                fill='#3f3d56'
              />
              <path
                d='M714.20735,141.38055H454.03775v-5.36232h-117.971v5.36232H74.82467a17.5985,17.5985,0,0,0-17.59852,17.59851V515.23125a17.59856,17.59856,0,0,0,17.59852,17.59858H714.20735a17.59856,17.59856,0,0,0,17.59852-17.59858V158.97906A17.5985,17.5985,0,0,0,714.20735,141.38055Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <rect
                x='50.4058'
                y='49.75362'
                width='627.3913'
                height='353.91304'
                fill='#00bfa6'
              />
              <circle cx='363.56522' cy='33.66667' r='6.43478' fill='#00bfa6' />
              <polygon
                points='498.374 403.667 50.406 403.667 50.406 49.754 498.374 403.667'
                opacity='0.1'
              />
              <circle
                cx='148.57375'
                cy='316.87641'
                r='60.3068'
                fill='#f2f2f2'
              />
              <rect
                x='509.95272'
                y='240.62175'
                width='58.6052'
                height='12.24586'
                fill='#3f3d56'
              />
              <rect
                x='439.10165'
                y='145.27896'
                width='200.30733'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='439.10165'
                y='161.89834'
                width='200.30733'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='439.10165'
                y='178.51773'
                width='200.30733'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='439.10165'
                y='195.13711'
                width='200.30733'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='439.10165'
                y='211.7565'
                width='200.30733'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='614.91726'
                y='56.9338'
                width='24.49173'
                height='24.49173'
                fill='#f2f2f2'
              />
              <path
                d='M681.1947,215.52507h-29.74v-29.74h29.74Zm-28.44691-1.293h27.15387V187.07816H652.74779Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <path
                d='M749.42165,519.96024H688.19234v-4.41153a.87468.87468,0,0,0-.87471-.87471h-20.9929a.87468.87468,0,0,0-.87471.87471v4.41153H652.32945v-4.41153a.87467.87467,0,0,0-.8747-.87471H630.46184a.87468.87468,0,0,0-.8747.87471v4.41153H616.46657v-4.41153a.87468.87468,0,0,0-.8747-.87471H594.599a.87468.87468,0,0,0-.87471.87471v4.41153H580.60369v-4.41153a.87468.87468,0,0,0-.87471-.87471H558.73607a.87468.87468,0,0,0-.8747.87471v4.41153H544.7408v-4.41153a.87468.87468,0,0,0-.8747-.87471H522.87319a.87467.87467,0,0,0-.8747.87471v4.41153H508.87792v-4.41153a.87468.87468,0,0,0-.87471-.87471h-20.9929a.87468.87468,0,0,0-.87471.87471v4.41153H473.015v-4.41153a.87468.87468,0,0,0-.8747-.87471H307.69588a.87468.87468,0,0,0-.8747.87471v4.41153H293.70061v-4.41153a.87468.87468,0,0,0-.8747-.87471H271.833a.87467.87467,0,0,0-.8747.87471v4.41153H257.83773v-4.41153a.87468.87468,0,0,0-.87471-.87471h-20.9929a.87468.87468,0,0,0-.87471.87471v4.41153H221.97484v-4.41153a.87467.87467,0,0,0-.8747-.87471H200.10723a.87468.87468,0,0,0-.8747.87471v4.41153H186.112v-4.41153a.87468.87468,0,0,0-.8747-.87471H164.24435a.87468.87468,0,0,0-.87471.87471v4.41153H150.24908v-4.41153a.87468.87468,0,0,0-.87471-.87471H128.38146a.87468.87468,0,0,0-.8747.87471v4.41153H114.38619v-4.41153a.87468.87468,0,0,0-.8747-.87471H92.51858a.87467.87467,0,0,0-.8747.87471v4.41153H51.40747a20.99293,20.99293,0,0,0-20.99291,20.99291v9.4925A20.99291,20.99291,0,0,0,51.40747,571.4385H749.42165a20.9929,20.9929,0,0,0,20.99291-20.99285v-9.4925A20.99292,20.99292,0,0,0,749.42165,519.96024Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <path
                d='M193.58593,477.27162a76,76,0,1,1,76-76A76.08614,76.08614,0,0,1,193.58593,477.27162Zm0-150a74,74,0,1,0,74,74A74.08385,74.08385,0,0,0,193.58593,327.27162Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <rect
                x='586.17137'
                y='32.54324'
                width='254.99951'
                height='2'
                fill='#3f3d56'
              />
              <rect
                x='406.17137'
                y='560.54324'
                width='732.99951'
                height='2'
                fill='#3f3d56'
              />
              <rect
                x='192.67161'
                y='652.54324'
                width='254.99951'
                height='2'
                fill='#3f3d56'
              />
              <rect x='471' y='550' width='28' height='28' fill='#00bfa6' />
              <path
                d='M546.41456,684.72838h-34v-34h34Zm-32.52174-1.47826H544.9363V652.20664H513.89282Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <rect x='796' y='22' width='28' height='28' fill='#00bfa6' />
              <path
                d='M871.41456,156.72838h-34v-34h34Zm-32.52174-1.47826H869.9363V124.20664H838.89282Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <rect x='1078' y='550' width='28' height='28' fill='#00bfa6' />
              <path
                d='M1153.41456,684.72838h-34v-34h34Zm-32.52174-1.47826h31.04348V652.20664h-31.04348Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <path
                d='M1087.58593,354.6866h-2.37862V289.525a37.71374,37.71374,0,0,0-37.71385-37.71377H909.44A37.71373,37.71373,0,0,0,871.72613,289.525V647.00639A37.71374,37.71374,0,0,0,909.44,684.72017h138.05348a37.71374,37.71374,0,0,0,37.71385-37.71378V401.06969h2.37862Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <path
                d='M1077.176,291.74159v356.96a28.16523,28.16523,0,0,1-28.16016,28.17H910.296a28.16511,28.16511,0,0,1-28.16-28.17v-356.96a28.163,28.163,0,0,1,28.16-28.16h16.83a13.3792,13.3792,0,0,0,12.39,18.43h79.09a13.37908,13.37908,0,0,0,12.38995-18.43h18.02A28.16308,28.16308,0,0,1,1077.176,291.74159Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#00bfa6'
              />
              <rect
                x='928.57968'
                y='376.21769'
                width='41.32357'
                height='12.24586'
                fill='#3f3d56'
              />
              <rect
                x='878.62133'
                y='280.8749'
                width='141.24028'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='878.62133'
                y='297.49429'
                width='141.24028'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='878.62133'
                y='314.11367'
                width='141.24028'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='878.62133'
                y='330.73306'
                width='141.24028'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='878.62133'
                y='347.35244'
                width='141.24028'
                height='5.24823'
                fill='#3f3d56'
              />
              <rect
                x='929.68352'
                y='211.17873'
                width='24.49173'
                height='24.49173'
                fill='#f2f2f2'
              />
              <path
                d='M969.47386,340.03163v29.74h29.74v-29.74Zm28.45,28.45h-27.16v-27.16h27.16Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <path
                d='M1077.176,610.58162v38.12a28.16523,28.16523,0,0,1-28.16016,28.17H910.296a28.16511,28.16511,0,0,1-28.16-28.17v-192.21l116.87,92.33,2,1.58,21.74,17.17,2.03,1.61Z'
                transform='translate(-30.41456 -122.72838)'
                opacity='0.1'
              />
              <circle
                cx='937.24147'
                cy='498.70691'
                r='43.86783'
                fill='#f2f2f2'
              />
              <path
                d='M350.58593,777.27162a87,87,0,1,1,87-87A87.09858,87.09858,0,0,1,350.58593,777.27162Zm0-172a85,85,0,1,0,85,85A85.09629,85.09629,0,0,0,350.58593,605.27162Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
              <path
                d='M980.58593,655.27162a55,55,0,1,1,55-55A55.06223,55.06223,0,0,1,980.58593,655.27162Zm0-108a53,53,0,1,0,53,53A53.05963,53.05963,0,0,0,980.58593,547.27162Z'
                transform='translate(-30.41456 -122.72838)'
                fill='#3f3d56'
              />
            </svg>
          </Box>
          <Box className='how-it-works' flex={1}>
            <h1>How does this App Work?</h1>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Sunt
              error fuga sit quod. Sit, officia.
            </p>
            <ul>
              <li>
                <Edit sx={{ color: 'aqua' }} />
                <Stack>
                  <Typography variant='h4' fontWeight={550}>
                    Create your account
                  </Typography>
                  <Typography variant='body2'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Quae et temporibus, quaerat nisi atque facilis.
                  </Typography>
                </Stack>
              </li>
              <li>
                <Image sx={{ color: 'aqua' }} />
                <Stack>
                  <Typography variant='h4' fontWeight={550}>
                    Upload your picture
                  </Typography>
                  <Typography variant='body2'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Quae et temporibus, quaerat nisi atque facilis.
                  </Typography>
                </Stack>
              </li>
              <li>
                <FilterVintage sx={{ color: 'aqua' }} />
                <Stack>
                  <Typography variant='h4' fontWeight={550}>
                    Get your own time
                  </Typography>
                  <Typography variant='body2'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Quae et temporibus, quaerat nisi atque facilis.
                  </Typography>
                </Stack>
              </li>
            </ul>
          </Box>
        </Container>

        <Container>
          <h1 style={{ textAlign: 'center' }}>Advanced features</h1>
          <p style={{ margin: 'auto', width: '50%', textAlign: 'center' }}>
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Magnam,
            quidem ex. Voluptates quidem doloribus delectus!
          </p>

          <Box display={'flex'} justifyContent='center'>
            <Grid
              p={2}
              container
              sx={{
                width: '80%',
                margin: 'auto',
              }}
              gap={{ sm: 1, xs: 1 }}
              columnGap='2px !important'
            >
              {gridItems.map((item, index) => (
                <Grid
                  className='grid-item'
                  key={index + 1}
                  item
                  sx={{
                    border: '1px solid aqua',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    p: '.4rem',
                    margin: 'auto',
                    backgroundColor: 'rgb(169,169,169, 0.05)',
                    borderRadius: '8px',
                  }}
                  xs={12}
                  sm={6}
                  md={3}
                >
                  {item.icon}
                  <Typography variant='h3' textAlign={'center'}>
                    {item.title}
                  </Typography>
                  <Typography variant='body2' textAlign={'center'}>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit.
                    Repudiandae, hic!.
                  </Typography>
                </Grid>
              ))}

              {/* <Grid item></Grid>
              <Grid item></Grid> */}
            </Grid>
          </Box>
        </Container>
      </Box>
    </>
  )
}

export default Features

const gridItems = [
  {
    title: 'Powerful System',
    icon: <Computer sx={{ color: 'aqua' }} />,
  },
  {
    title: 'Personalization',
    icon: <Edit sx={{ color: 'aqua' }} />,
  },
  {
    title: 'Ease of Acces',
    icon: <FilterVintage sx={{ color: 'aqua' }} />,
  },
  {
    title: 'Time and language',
    icon: <AccessTime sx={{ color: 'aqua' }} />,
  },
  {
    title: 'Free accounts',
    icon: <ManageAccounts sx={{ color: 'aqua' }} />,
  },
  {
    title: 'Security',
    icon: <Security sx={{ color: 'aqua' }} />,
  },
]
